import { TagsType } from "@components/Common/HomeworkTemplate/Modals/types";

import { TagInputComponent } from "./tag-input.component";
import { useTagInputService } from "./tag-input.service";

type Props = {
  tagInputValue: TagsType | null;
  handleTagInputChange: (value: string, shouldSave?: boolean) => void;
  handleTagInputBlur: () => void;
};

export const TagInputContainer = ({
  tagInputValue,
  handleTagInputChange,
  handleTagInputBlur,
}: Props) => {
  const { onChange, searchedTags, isLoadingTags } = useTagInputService({
    handleChange: handleTagInputChange,
  });
  return (
    <TagInputComponent
      tagInputValue={tagInputValue}
      handleChange={onChange}
      searchedTags={searchedTags}
      onBlur={handleTagInputBlur}
      isLoadingTags={isLoadingTags}
    />
  );
};
